import React, { Component } from 'react';
import { isEmpty } from "lodash";
import { Box, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, IconButton, Typography } from '@mui/material';
import { AddCircleOutlineRounded, CloudDownloadRounded } from '@mui/icons-material';
import DemandsForm from './Demands/DemandsForm';
// import DemandDetails from '../Admin/Demand/DemandDetails';

class EmployeeDemandList extends Component {
    state = {
        openDetails: false,
        session: {},

    }
    componentDidMount = () => {
        if(isEmpty(this.props.ARTICLES)){
            this.props.fetchArticles()
        }
        if(isEmpty(this.props.DEMANDS)){
            this.props.fetchUserDemands()
        }
    }
    handleClose = () => {
        this.setState({ 
            openDetails: false,
            session: {},
        });
    };    
    
    render() {
        const { CURRENT_SESSION, employee } = this.props;
        const { openDetails, session } = this.state;
        return (
            <Box p={2}>
                {openDetails && !isEmpty(session) && 
                    <DemandsForm 
                        handleClose={this.handleClose} 
                        {...this.props} 
                        SESSION={session} 
                        currentEmployee={employee} 
                    />
                }
                {/* <Typography variant="h5" id="tableTitle">
                    Liste des Demandes
                </Typography> */}
                <TableContainer>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Date de Début</TableCell>
                                <TableCell>Date de Fin</TableCell>
                                <TableCell>Nom</TableCell>
                                <TableCell>Options</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {!isEmpty(CURRENT_SESSION) ? CURRENT_SESSION.map( item => (
                                <TableRow key={item.session_id}>
                                    <TableCell>
                                        {new Date(item.session_creation_date).toLocaleDateString("fr-FR")}
                                    </TableCell>
                                    <TableCell>
                                        {item.session_is_over ? new Date(item.session_end_date).toLocaleDateString("fr-FR") : "en cours"}
                                    </TableCell>
                                    <TableCell>{item.session_name}</TableCell>
                                    <TableCell>
                                        <IconButton onClick={
                                            () => this.setState({ openDetails: true, session: item })
                                        }>
                                            <AddCircleOutlineRounded />
                                        </IconButton>
                                    </TableCell>
                                    
                                </TableRow>
                            )):
                            <Typography variant="button" id="tableTitle">
                                Pas de Session pour le moment
                            </Typography>
                            }
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>
        );
    }
}

export default EmployeeDemandList;